import React, { FC, memo } from "react";
import { useSelector } from "react-redux";
import { Chip, IconButton, ThemeName } from "@evergis/ui";

import { PageName, PagesWrapper, PaginationWrapper, PresentationButton, PresentationHeaderImage } from "../styled";
import { Pagination } from "../components/Pagination/Pagination";
import { getThemeName } from "../../../ducks/theme/selectors";
import { usePresentationMode } from "../../../hooks/layout/usePresentationMode";
import { useConfigPages } from "../../Dashboard/hooks/useConfigPages";
import { usePageConfig } from "../../Dashboard/hooks/usePageConfig";
import { ContainerProps } from "../types";

export const PaginationContainer: FC<ContainerProps> = memo(({ type }) => {
  const themeName = useSelector(getThemeName);
  const { togglePresentationMode } = usePresentationMode();
  const { isPresentationMode } = usePresentationMode();
  const { currentPageIndex, pages } = useConfigPages(type);
  const { getPageTitle, getPageImage } = usePageConfig(type);

  if (!pages.length || isPresentationMode) return null;

  const pageTitle = getPageTitle(currentPageIndex);
  const pageImage = getPageImage(currentPageIndex);

  return (
    <PaginationWrapper image={pageImage}>
      <PagesWrapper>
        <PageName>
          <Chip>{pageTitle}</Chip>
        </PageName>
        {!pageImage && <Pagination type={type} />}
      </PagesWrapper>
      <PresentationButton>
        {!!pageImage && <Pagination type={type} />}
        <IconButton kind="play" onClick={togglePresentationMode} />
      </PresentationButton>
      {!!pageImage && <PresentationHeaderImage image={pageImage} isDark={themeName === ThemeName.Dark} />}
    </PaginationWrapper>
  );
});
